/* eslint-disable @typescript-eslint/no-explicit-any */
 
import { getDb, generateId } from '../db/connection';

export const DatabaseService = {
  async add(storeName: string, data: any) {
    try {
      const db = await getDb();
      const id = generateId(storeName);
      const tx = db.transaction(storeName, 'readwrite');
      const store = tx.objectStore(storeName);
      await store.add({ ...data, id });
      await tx.done; // Wait for transaction to complete
      return id;
    } catch (error: any) {
      if (error?.name === 'NotFoundError' || error?.message?.includes('object store')) {
        console.error(`Object store '${storeName}' not found. Database schema may be outdated.`);
        localStorage.setItem('dbNeedsClearing', 'true');
        throw new Error(`Database schema error: ${storeName} store not found`);
      }
      throw error;
    }
  },

  async get(storeName: string, id: string) {
    try {
      const db = await getDb();
      return await db.get(storeName, id);
    } catch (error: any) {
      if (error?.name === 'NotFoundError' || error?.message?.includes('object store')) {
        console.error(`Object store '${storeName}' not found. Database schema may be outdated.`);
        localStorage.setItem('dbNeedsClearing', 'true');
        return null;
      }
      throw error;
    }
  },

  async getAll(storeName: string) {
    const db = await getDb();
    return await db.getAll(storeName);
  },

  async getAllByIndex(storeName: string, indexName: string, value: any) {
    const db = await getDb();
    const tx = db.transaction(storeName, 'readonly');
    const store = tx.objectStore(storeName);
    const index = store.index(indexName);
    return await index.getAll(value);
  },

  async update(storeName: string, id: string, data: any) {
    const db = await getDb();
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    const current = await store.get(id);
    if (!current) return false;
    await store.put({ ...current, ...data, updatedAt: Date.now() });
    await tx.done; // Wait for transaction to complete
    return true;
  },

  async delete(storeName: string, id: string) {
    const db = await getDb();
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    await store.delete(id);
    await tx.done; // Wait for transaction to complete
    return true;
  },

  async clear(storeName: string) {
    const db = await getDb();
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    await store.clear();
    await tx.done; // Wait for transaction to complete
    return true;
  }
}; 